export default function initMediaContentVideo() {
    /**
     * ------------------------------------------------------
     * MODAL VIDÉO
     * ------------------------------------------------------
     */
    const sections = document.querySelectorAll(".media-content");

    sections.forEach((section) => {
        const openButton = section.querySelector("[data-media-video-open]");

        const modal = section.querySelector("[data-media-video-modal]");

        const iframe = section.querySelector("[data-media-video-iframe]");

        const closeButtons = section.querySelectorAll("[data-media-video-close]");

        if (!openButton || !modal || !iframe) {
            return;
        }

        const videoUrl = openButton.dataset.videoUrl;

        const openModal = () => {
            if (!videoUrl) {
                return;
            }

            const separator = videoUrl.includes("?") ? "&" : "?";

            iframe.src = `${videoUrl}${separator}autoplay=1&controls=0&cc_load_policy=0&rel=0&playsinline=1`;

            modal.classList.remove("hidden");
            modal.classList.add("flex");

            modal.setAttribute("aria-hidden", "false");

            document.body.style.overflow = "hidden";
        };

        const closeModal = () => {
            modal.classList.add("hidden");
            modal.classList.remove("flex");

            modal.setAttribute("aria-hidden", "true");

            iframe.src = "";

            document.body.style.overflow = "";
        };

        openButton.addEventListener("click", openModal);

        closeButtons.forEach((button) => {
            button.addEventListener("click", closeModal);
        });

        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape" && !modal.classList.contains("hidden")) {
                closeModal();
            }
        });
    });
}
